import React from 'react'
import PropTypes from 'prop-types'
import { Colours, Sizes } from '../../style_helpers'

const CloseIcon = (props) => {
  return (
    <svg style={props.style} width={props.width} height={props.height} viewBox='0 0 12 12' xmlns='http://www.w3.org/2000/svg'>
      <g strokeWidth='2' stroke={props.colour} fill='none' fillRule='evenodd' strokeLinecap='round' strokeLinejoin='round'>
        <path d='M11 1L1 11M1 1l10 10' />
      </g>
    </svg>
  )
}

CloseIcon.propTypes = {
  colour: PropTypes.string,
  height: PropTypes.string,
  width: PropTypes.string,
  style: PropTypes.object
}

CloseIcon.defaultProps = {
  colour: Colours('grey', '500'),
  height: Sizes(4),
  width: Sizes(0),
  style: {}
}

export default CloseIcon
